import { Component, Input } from '@angular/core';
import { InvoiceModel } from 'app/models/invoice.model';
import { NexusComponent } from '../nexus/nexus.component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'module-nexus-invoice-information',
    templateUrl: './nexus-invoice-information.component.html',
    styleUrls: ['./nexus-invoice-information.component.scss'],
    standalone: false
})
export class NexusInvoiceInformationComponent extends NexusComponent {
  @Input() public invoice_model: InvoiceModel;

  constructor() {
    super();
   }

}
